/**
 * Shifts Create Page — hardcoded form.
 */

import * as React from 'react';
import { useNavigate } from 'react-router';
import { useCreate } from '@refinedev/core';
import {
  Button, Card, CardContent, Input, Label, Checkbox,
} from '@yesbos/ui';
import { ArrowLeft } from 'lucide-react';

export function ShiftsCreatePage() {
  const navigate = useNavigate();
  const { mutate: create, isLoading } = useCreate();
  const [form, setForm] = React.useState({
    name: '', start_time: '09:00', end_time: '18:00', break_duration: 60, is_night_shift: false,
  });
  const set = (f: string, v: unknown) => setForm(p => ({ ...p, [f]: v }));

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    create(
      { resource: 'shifts', values: form },
      { onSuccess: () => navigate('/shifts') },
    );
  }

  return (
    <div className="p-6 max-w-xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <Button variant="ghost" size="icon" onClick={() => navigate('/shifts')}><ArrowLeft className="h-4 w-4" /></Button>
        <h1 className="text-2xl font-semibold">Create Shift</h1>
      </div>
      <Card>
        <CardContent className="pt-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1">
              <Label htmlFor="name">Shift Name *</Label>
              <Input id="name" value={form.name} onChange={e => set('name', e.target.value)} required placeholder="e.g. General Shift, Morning Shift" />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-1">
                <Label htmlFor="start_time">Start Time</Label>
                <Input id="start_time" type="time" value={form.start_time} onChange={e => set('start_time', e.target.value)} />
              </div>
              <div className="space-y-1">
                <Label htmlFor="end_time">End Time</Label>
                <Input id="end_time" type="time" value={form.end_time} onChange={e => set('end_time', e.target.value)} />
              </div>
            </div>
            <div className="space-y-1">
              <Label htmlFor="break_duration">Break Duration (minutes)</Label>
              <Input id="break_duration" type="number" min={0} max={480} value={form.break_duration} onChange={e => set('break_duration', parseInt(e.target.value) || 0)} />
            </div>
            <label className="flex items-center gap-2 cursor-pointer">
              <Checkbox checked={form.is_night_shift} onCheckedChange={v => set('is_night_shift', v)} />
              <span className="text-sm">Night Shift</span>
            </label>
            <div className="flex justify-end gap-3 pt-2">
              <Button type="button" variant="outline" onClick={() => navigate('/shifts')}>Cancel</Button>
              <Button type="submit" disabled={isLoading}>{isLoading ? 'Creating...' : 'Create Shift'}</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}

export default ShiftsCreatePage;
